// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AlpineLinuxIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 44 39">
    <path
      fill="#0D597F"
      d="M15.95 23.71v-4.64l-3.34 3.34a10 10 0 0 0 1.9 1.02 5 5 0 0 0 1.44.28m17.08-.39q0 .01.1.07.08.07.26.14t.44.13a3 3 0 0 0 1.27 0q.36-.05.78-.2t.91-.4q.48-.25 1.03-.63l-2.53-2.48-8.39-8.43-3.7 3.7-4.96-5.11L5.77 22.43q.55.38 1.03.63a7 7 0 0 0 1.69.6 4 4 0 0 0 1.28 0 2 2 0 0 0 .7-.27l.1-.07 5.64-5.64 2.01-1.93 5.59 5.58 1.95 2q0 .02.1.08.09.06.26.13t.44.14a3 3 0 0 0 1.27 0q.36-.06.78-.2.43-.16.91-.4t1.04-.64l-4.47-4.37.84-.83 3.87 3.87 2.26 2.23M33 0 44 19.06 33 38.12H11L0 19.06 11 0z"
    />
  </svg>,
  "AlpineLinux",
);
export default AlpineLinuxIcon;
